export async function reconcilePersistedSupersetSetUpdate({
  updates,
  shouldReview = typeof updates?.complete === 'boolean',
  workoutExerciseId,
  refreshWorkout,
  requestCoachReview,
  isCurrent = () => true,
}) {
  if (!shouldReview || !isCurrent()) return;

  // Refresh is reconciliation, not the write. A failed read must not turn an
  // acknowledged mutation into a failed mutation or invite another completion.
  try {
    if (typeof refreshWorkout === 'function') await refreshWorkout();
  } catch (_) { /* The direct review reads canonical evidence on the server. */ }

  // Always schedule from the acknowledged occurrence, even if uncomplete →
  // complete returned to the same count before the parent saw intermediate state.
  // Workout coalesces this with its state-change review using the same scope key.
  if (isCurrent() && typeof requestCoachReview === 'function') {
    requestCoachReview(workoutExerciseId);
  }
}
